// apiWebToken.ts

import { Preferences } from '@capacitor/preferences';

/**
 * Extracts the JWT token from the browser cookies.
 * @returns The JWT token if found, otherwise undefined.
 */
const getJwtToken = async (): Promise<string | undefined> => {
    const jwtToken = await Preferences.get({ key : 'tokenV1'});
    if (jwtToken && jwtToken.value) {
        return jwtToken.value;
    }else{
        let oldjwtToken = localStorage.getItem('tokenV1');

        if (oldjwtToken) {
            await Preferences.set({ key : 'tokenV1', value : oldjwtToken });
            localStorage.removeItem('tokenV1');
            return oldjwtToken;
        }
    }
};

export { getJwtToken };
